import { _callBackend } from '@/_api/api';
import type { APIRequest, APIResponsePromise } from '@/_types/api';
import type { TaxReturn } from '@/_types/models/taxReturns';

export const getTaxReturns = async ({
  companyId,
  token,
}: APIRequest<{
  companyId: number;
}>): APIResponsePromise<Array<TaxReturn>> =>
  await _callBackend(
    `/tax_returns?company_id=${companyId}`,
    'GET',
    null,
    token,
  );

export const updateTaxReturnK1Packages = async ({
  id,
  companyId,
  token,
  k1_packages,
}: APIRequest<{
  id: number;
  companyId: number;
  k1_packages?: Array<{
    document_path: string;
    partner_email: string;
    partner_name: string;
    custom_package_name: string;
    sent_at_to_partner: number | null;
    viewed_at_by_partner: number | null;
  }>;
}>): APIResponsePromise<TaxReturn> =>
  await _callBackend(
    `/tax_returns/${id}?company_id=${companyId}`,
    'PATCH',
    {
      k1_packages,
    },
    token,
  );

export const sendK1PackageToPartner = async ({
  company_id,
  tax_return_id,
  document_path,
  partner_email,
  partner_name,
  token,
}: APIRequest<{
  company_id: number;
  tax_return_id: number;
  document_path: string;
  partner_email: string;
  partner_name: string;
}>): APIResponsePromise<void> =>
  await _callBackend(
    `/tax_returns/${tax_return_id}/send_k1_package_to_partner`,
    'POST',
    {
      company_id,
      document_path,
      partner_email,
      partner_name,
    },
    token,
  );
